module.exports = __webpack_public_path__ + "static/media/team.da408d18.svg";